import theme from '../theme';

const { media, colors, font, scale } = theme;

export default () => ({
  acfBlock: {},

  blockStackOnMobile: {
    display: 'flex !important',

    [media.l.down]: {
      flexDirection: 'column !important',

      '> *': {
        width: '100% !important',
      },
    },
  },

  blockHeader: {
    margin: '0 !important',
    padding: '0 !important',

    '+ *': {
      marginTop: `${scale.s} !important`,
    },
  },

  blockTitle: {
    color: colors.black,
    margin: '0 !important',
    fontWeight: 700,
    fontFamily: font.families.primary,
    fontSize: font.xxl,
  },

  blockSubtitle: {
    color: colors.black,
    margin: '0 !important',
    fontWeight: 500,
    fontFamily: font.families.primary,
    fontSize: font.xxl,

    //  p tag injected when using dangerouslySetInnerHTML
    '> p': {
      margin: '0 !important',
      marginTop: '0 !important',
      marginBottom: '0 !important',
      color: colors.black,
      fontFamily: font.families.primary,
    },
  },

  blockContentWrapper: {
    marginTop: scale.s,
  },
});
